import React, { Component } from 'react';

import Page from './Page.jsx';
import Divider from './Divider.jsx';

class Paginator extends Component {
  constructor(props) {
    super(props);
    this.state={
      max_blocks:10
    };
  }
  getPages() {
    let pages=parseInt(this.props.count/this.props.rows_per_page);
    pages+=this.props.count % this.props.rows_per_page?1:0;
    return pages;
  }
  renderPages() {
    let pages;

    if (this.props.pages === void 0) {
      pages=parseInt(this.props.count/this.props.rows_per_page);
      pages+=this.props.count % this.props.rows_per_page?1:0;
    } else {
      pages = this.props.pages;
    }

    if(pages<=1) {
      return null;
    }

    let pagesItems=[];
    const func=(i)=>{
      this.props.changer(i);
    };

    pagesItems.push(
      <Page
        key={`page-0`}
        page={1}
        selected={this.props.page===1}
        onClick={func.bind(this,1)}
      />
    );

    const halfBlock=this.state.max_blocks/2;
    let left=this.props.page-halfBlock;
    let right=this.props.page+halfBlock;
    //console.log("range",this.props.page-halfBlock,this.props.page+halfBlock);
    if(left<1) {
      right+=(1-left);
    }
    if(right>(pages-2)) {
      left-=(right-pages)+2;
    }
    let first=true;
    for(let i=1;i<(pages-1);i++) {
      if(i>=left && i<=right) {
        pagesItems.push(
          <Page
            key={`page-${i}`}
            page={i+1}
            selected={this.props.page===(i+1)}
            onClick={func.bind(this,i+1)}
          />
        );
      }
    }

    pagesItems.push(
      <Page
        key={`page-${pages}`}
        page={pages}
        selected={this.props.page===(pages)}
        onClick={func.bind(this,pages)}
      />
    );

    if(pagesItems[0].props.page !== (pagesItems[1].props.page-1)) {
      pagesItems.splice(1, 0, <Divider key={`divider-1`} />);
    }
    if(pagesItems[pagesItems.length-1].props.page !== (pagesItems[pagesItems.length-2].props.page+1)) {
      pagesItems.splice(pagesItems.length-1, 0, <Divider key={`divider-2`} />);
    }

    return pagesItems;
  }
  renderPagesSelector() {
    let pages;

    if (this.props.pages === void 0) {
      pages = parseInt(this.props.count / this.props.rows_per_page);
      pages += this.props.count % this.props.rows_per_page ? 1 : 0;
    } else {
      pages = this.props.pages;
    }

    if (pages <= 1) {
      return null;
    }

    let pagesItems = [];
    const func = (i) => {
      this.props.changer(i);
    };

    pagesItems.push(
      <option
        key={`page-0`}
        value={1}
      >{1}</option>
    );

    const halfBlock = this.state.max_blocks / 2;
    let left = this.props.page - halfBlock;
    let right = this.props.page + halfBlock;
    //console.log("range",this.props.page-halfBlock,this.props.page+halfBlock);
    if (left < 1) {
      right += (1 - left);
    }
    if (right > (pages - 2)) {
      left -= (right - pages) + 2;
    }
    let first = true;
    for (let i = 1; i < (pages - 1); i++) {
      if (i >= left && i <= right) {
        pagesItems.push(
          <option
            key={`page-${i}`}
            value={i + 1}
          >{i+1}</option>
        );
      }
    }

    pagesItems.push(
      <option
        key={`page-${pages}`}
        value={pages}
      >{pages}</option>
    );

    if (pagesItems[0].props.page !== (pagesItems[1].props.page - 1)) {
      pagesItems.splice(1, 0, <option disabled={true} key={`divider-1`}>...</option>);
    }
    if (pagesItems[pagesItems.length - 1].props.page !== (pagesItems[pagesItems.length - 2].props.page + 1)) {
      pagesItems.splice(pagesItems.length - 1, 0, <option key={`divider-2`} disabled={true}>...</option>);
    }

    return (
      <span className="select big"><select value={this.props.page} onChange={(e)=>{
        this.props.changer(e.target.value);
      }}>{pagesItems}</select></span>
    );
  }
  render() {
    if(this.getPages()===1) {
      return null;
    }
    return (
      <div className="paginator up12 margin ptop10">
        <div className="cell s-shrink s-middle">
          
          <Page disabled={this.props.page-1<=0} page={"Prev"} onClick={()=>{
            this.props.changer(this.props.page-1);
          }} />
          
        </div>
        <div className="cell s-auto tac s-middle">
          <div className="only-s-dn">
            {this.renderPages()}
          </div>
          <div className="m-dn ">
            {this.renderPagesSelector()}
          </div>
        </div>
        <div className="cell s-shrink s-middle">

          <Page disabled={this.props.page+1>this.getPages()} page={"Next"} onClick={()=>{
            this.props.changer(this.props.page+1);
          }} />

        </div>
      </div>
    )
  }
}

export default Paginator;
